const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  addresscodeParse ({ state, commit, rootState }, params) {
    return rootState.axios.get('/magicbuy/ali-dg/logistics/addresscode-parse', {
      params,
      baseURL: 'https://apisp.jyb.com.tw',
    })
  },
  freightEstimate ({ state, commit, rootState }, params) {
    return rootState.axios.get('/magicbuy/ali-dg/logistics/freight-estimate', {
      params,
      noShowError: true,
      baseURL: 'https://apisp.jyb.com.tw',
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
